import { Link, createFileRoute } from "@tanstack/react-router";

import { ComplaintTrackForm } from "~/components/ComplaintTrackForm";
import { useI18n } from "~/lib/i18n";
import { ui } from "~/lib/ui";

export const Route = createFileRoute("/complaints/")({
  component: Complaints,
});

function Complaints() {
  const { t } = useI18n();

  return (
    <div className="mx-auto max-w-xl space-y-6">
      <div>
        <h1 className={ui.h1}>{t("complaintsTitle")}</h1>
        <p className={ui.lead}>{t("complaintsIntro")}</p>
      </div>
      <Link
        to="/complaints/new"
        className="block w-full rounded-lg bg-ink px-4 py-3 text-center font-semibold text-white sm:inline-block sm:w-auto dark:bg-ink-dark dark:text-slate-950"
      >
        {t("reportProblem")}
      </Link>
      <section className="rounded-xl border border-slate-200 p-4 dark:border-slate-800">
        <h2 className="mb-3 font-semibold">{t("trackComplaint")}</h2>
        <ComplaintTrackForm />
      </section>
    </div>
  );
}
